import { render, staticRenderFns } from "./exhibition.vue?vue&type=template&id=89b357ee&scoped=true&"
import script from "./exhibition.vue?vue&type=script&lang=js&"
export * from "./exhibition.vue?vue&type=script&lang=js&"
import style0 from "./exhibition.vue?vue&type=style&index=0&id=89b357ee&prod&scoped=true&lang=scss&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "89b357ee",
  null
  
)

export default component.exports